module.exports = __webpack_public_path__ + "img/GreekTechPalintononS_ua.1698b14e.webp";